import React from 'react';
import {NavLink} from 'react-router-dom'

function Footer(props) {
    return (
        <div className="bg-light p-4">
            <section className="footer d-flex justify-content-between align-items-center">
                <div className="quick-links">
                    <ul className="navbar-nav mx-auto mb-lg-0 ">
                        <li className="nav-item px-3">
                            <NavLink className="nav-link active" aria-current="page" to="/">Home</NavLink>
                        </li>
                        <li className="nav-item px-3">
                            <NavLink className="nav-link" to="/program">Programs</NavLink>
                        </li>
                        <li className="nav-item px-3">
                            <NavLink className="nav-link" to="/about">About Us</NavLink>
                        </li>
                        <li className="nav-item px-3">
                            <NavLink className="nav-link" to="/contact">Contact</NavLink>
                        </li>
                        <div className="buy-form px-3">
                            <NavLink to="/signup" className="purchase-btn btn btn-info text-white">
                                Entry form
                            </NavLink>
                        </div>
                    </ul>
                </div>
                <div className="contacts">
                    <ul className="socials nav d-grid ">
                        <li className="facebook social-item py-2">
                        <a href="https://facebook.com" className="social-links text-decoration-none ml-2">
                        <i className="fab fa-facebook text-primary fa-2x"></i>
                        </a>
                        </li>
                        <li className="Twitter social-item py-2">
                        <a href="https://twitter.com" className="social-links text-decoration-none">
                        <i className="fab fa-twitter fa-2x text-info"></i>
                        </a>
                        </li>
                        <li className="Instagram social-item py-2">
                        <a href="https://instagram.com" className="social-links text-decoration-none">
                        <i className="fab fa-instagram fa-2x text-danger"></i>
                        </a>
                        </li>
                        <li className="linkedin social-item py-2">
                        <a href="https://linkedin.com" className="social-links text-decoration-none">
                        <i className="fab fa-linkedin fa-2x text-primary"></i>
                        </a>
                        </li>
                    </ul>
                    
                </div>
                <div className="adrress px-3">
                    <div className="office">
                        <address>
                            Lorem ipsum dolor sit amet, <br/>
                            consectetur adipisicing elit.
                        </address>
                        <span className="phone">
                            <a href="tel:+234 567 891011">+234 567 891011</a>
                        </span>
                        <div className="email">
                            <a href="mailto:eti@gmail.com" className="email-link text-decoration-none">
                                eti@gmail.com
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            <hr/>
            <div className="copyright-info">
                <p className="copyright text-center">
                    &copy;Edugen 2021.
                    <span> All Rights Reserved</span>
                </p>
            </div>
        </div>
    );
}

export default Footer;